import Page from "components/Page";
import { Props } from "./ReasonCodes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const ReasonCodes = lazyWithRetry(() => import("./ReasonCodes"));

export default (props: Props) => (
  <Page>
    <ReasonCodes {...props} />
  </Page>
);